import React from 'react';
import classes from './styles/placeholder.module.css';

const PlaceHolder = () => {
  return (
    <div className={classes.placeholder}>
      <p className={classes.glow}>
        <span className={classes.heading}></span><br />
        <span className={classes.date}></span><br />
        <span className={classes.date}></span><br />
        {/* <span className={classes.date}></span><br /> */}
        {/* <span className={classes.description1}></span><br /> */}
        {/* <span className={classes.description2}></span><br /> */}
      </p>
    </div>
  );
};

export default PlaceHolder;
